module.exports = __webpack_public_path__ + "static/mockup-2344ee21e661bd89aaf7584855f685a7.png";